<template lang="html">
  <div
    v-tracking-context="{ event_element: 'sort_edit' }"
    class="filter-summary__sort-wrapper filter-summary__action small-2 medium-4"
  >
    <transition name="fade">
      <ul v-if="isSortVisible" class="filter-summary__sort-dropdown">
        <li
          v-for="(val, key) in sortOptions"
          :key="key"
          v-click-track="{ action_type: 'sort_select', target: `#${key}` }"
          class="filter-summary__sort-option"
          :class="optionClasses(key)"
          @click="onClickOption(key)"
        >
          {{ val }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import fromPairs from 'lodash-es/fromPairs'

export default {
  data() {
    return {
      sortOptionNames: this.$options.filters.t('client.filter_summary.sort'),
      sortOptionsOrder: this.$options.filters.t(
        'client.filter_summary.sort_order'
      )
    }
  },
  computed: {
    ...mapGetters(['isSortVisible']),
    ...mapState(['searchProfile']),
    sortOptions() {
      const sortOptionsOrderList = [...this.sortOptionsOrder]
      // Customer requests that "relevance" is only availble on search page with custom tag
      if (this.searchProfile.customTags.length === 0) {
        const index = sortOptionsOrderList.indexOf('STANDARD')
        if (index > -1) {
          sortOptionsOrderList.splice(index, 1)
        }
      }
      return fromPairs(
        sortOptionsOrderList.map(option => [
          option,
          this.sortOptionNames[option]
        ])
      )
    },
    optionClasses() {
      return key => {
        const isActive = key === this.$store.state.sort
        return {
          'filter-summary__sort-option--active': isActive,
          'filter-summary__sort-option--active-non-default':
            isActive && key !== 'STANDARD'
        }
      }
    }
  },

  methods: {
    ...mapMutations(['sortSet']),
    ...mapActions(['sortToggle']),
    onClickOption(key) {
      this.$store.commit('sortSet', { sort: key })
      this.sortToggle()
    }
  }
}
</script>
